import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-comment-input',
  templateUrl: './comment-input.component.html',
  styleUrls: ['./comment-input.component.scss']
})
export class CommentInputComponent implements OnInit, OnChanges {
  @Input() actionButtonLabel: string = 'Post comment';
  @Output() action: EventEmitter<void> = new EventEmitter();
  @Output() cancel?: EventEmitter<void> = new EventEmitter();
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() value: string = '';
  @Output() valueChange = new EventEmitter<string>();
  @Input() contentLength: number = 200;
  @Input() disabledAction: boolean = false;
  @Input() showActionLoading?: boolean = false;
  @Input() anonymousName?: string = '';
  @Output() anonymousNameChange = new EventEmitter<string>();

  public commentForm: FormControl;

  constructor() {}

  ngOnInit(): void {
    const contentValidators = [
      Validators.maxLength(this.contentLength),
      Validators.minLength(1),
    ];
    this.commentForm = new FormControl(this.value, contentValidators);
    this.commentForm.valueChanges.subscribe(value => {
      this.valueChange.emit(value);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] && this.commentForm) {
      this.commentForm.setValue(this.value);
    }
  }

  public actionClick = () => {
    this.action.emit();
  }

  public cancelClick = () => {
    if (this.cancel) {
      this.cancel.emit();
    }
  }

  public anonymousNameInputChange = (value: string) => {
    this.anonymousNameChange.emit(value);
  }
}
